import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-profile-intro',
    standalone: true,
    imports: [RouterLink, MatCardModule, MatButtonModule, MatMenuModule],
    templateUrl: './profile-intro.component.html',
    styleUrl: './profile-intro.component.scss'
})
export class ProfileIntroComponent implements OnInit {
    user: any = {}; // Stockera les données de l'utilisateur
    isToggled = false;

    constructor(public themeService: CustomizerSettingsService) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
        this.loadUserFromSession();
    }

    loadUserFromSession() {
        const role = sessionStorage.getItem('user_roles');

        this.user = {
            id: sessionStorage.getItem('user_id'),
            name: sessionStorage.getItem('user_name'),
            username: sessionStorage.getItem('user_username'),
            roles: role ? this.mapRole(role) : 'Utilisateur',
        };
    }

    // Méthode pour mapper les rôles en labels plus lisibles
    mapRole(role: string): string {
        const roleMappings: { [key: string]: string } = {
            'ROLE_ROLE_ADMIN': 'Administrateur',
            'ROLE_ROLE_WORKER': 'Worker',
            'ROLE_ROLE_USER': 'Utilisateur',
            'ROLE_ROLE_MANAGER': 'Manager',
        }; 
        return roleMappings[role] || 'Utilisateur';
    }

    // Mode RTL
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }
}
